import { ButtonSizes } from "@roc-digital/ui-web";
import { Button, ButtonVariants } from "../Button";
import { Heading2 } from "../Typefaces";
import { Modal } from "../Modal";

export function confirm(content: any, title: string) {
  return new Promise<boolean>((res, rej) => {
    Modal.open('mxm.modal', <ConfirmModal
      title={title}
      content={content}
      onYes={() => res(true)}
      onNo={() => res(false)}
    />, 'medium');
  });
}

interface ConfirmModalProps {
  title: string;
  content: any;
  onYes: () => void;
  onNo?: () => void;
}

function ConfirmModal(props: ConfirmModalProps) {

  const closeModal = () => {
    Modal.close('mxm.modal');
  };

  return <div className="p-8">
    <Heading2 className={'mb-8 text-admin-dark !font-extrabold !text-[26px]'}>{props.title}</Heading2>
    <div>
      <br />
      {props.content}
      <br /><br />
    </div>

    <div>
      <div className="mt-4 flex inline-block gap-2">
        <Button clickEvent={() => {
          if(props.onNo) props.onNo();
          closeModal();
        }} size={ButtonSizes.medium} variant={ButtonVariants.secondary}>No</Button>
        <span className="flex-grow"></span>
        <Button clickEvent={() => {
          closeModal();
          props.onYes();
        }} size={ButtonSizes.medium}>Yes</Button>
      </div>
    </div>
  </div>
}